export default {
  DEFAULT: 'default',
  FIXED: 'fixed' // fixed without overlay
}
